// External Link Icon
const allLinks = document.querySelectorAll('a[href]');

allLinks.forEach(link => {
  const hrefAttr = link.getAttribute('href');

  // Skip links with no href, pure hashes, or JS pseudo links
  if (!hrefAttr || hrefAttr === '#' || hrefAttr.startsWith('javascript:')) {
    return;
  }

  // Skip mailto links
  if (hrefAttr.startsWith('mailto:')) {
    return;
  }

  let linkHostname;

  // Safely build a URL using the current origin as the base
  try {
    const url = new URL(hrefAttr, window.location.origin);
    linkHostname = url.hostname;
  } catch (e) {
    // If we still cannot build a URL, skip this link instead of crashing the page
    return;
  }

  const windowHostname = window.location.hostname;

  if (linkHostname !== windowHostname) {
    link.setAttribute('target', '_blank');

    const buttonElement = link.querySelector('.button');

    if (buttonElement !== null) {
      buttonElement.classList.add('button-row');
      buttonElement.innerHTML += '<span class="external"> <span class="sr">(external link)</span><svg height="12" width="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15,10 L15,14 C15,15.1045695 14.1045695,16 13,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,3 C0,1.8954305 0.8954305,1 2,1 L6,1 L6,3 L2,3 L2,14 L13,14 L13,10 L15,10 Z M13.9971001,3.41421356 L7.70420685,9.70710678 L6.28999329,8.29289322 L12.5828865,2 L8.99710007,2 L8.99710007,0 L15.9971001,0 L15.9971001,7 L13.9971001,7 L13.9971001,3.41421356 Z" fill-rule="evenodd"/></svg></span>';
    } else {
      link.innerHTML += '<span class="external"> <span class="sr">(external link)</span><svg height="12" width="12" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15,10 L15,14 C15,15.1045695 14.1045695,16 13,16 L2,16 C0.8954305,16 0,15.1045695 0,14 L0,3 C0,1.8954305 0.8954305,1 2,1 L6,1 L6,3 L2,3 L2,14 L13,14 L13,10 L15,10 Z M13.9971001,3.41421356 L7.70420685,9.70710678 L6.28999329,8.29289322 L12.5828865,2 L8.99710007,2 L8.99710007,0 L15.9971001,0 L15.9971001,7 L13.9971001,7 L13.9971001,3.41421356 Z" fill-rule="evenodd"/></svg></span>';
    }
  }
});
